"use client";

const DAY_MS = 24 * 60 * 60 * 1000;
const WEEKDAYS = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

const padTimePart = (value: number) => String(value).padStart(2, "0");

export function formatMessageTimestamp(value?: string | Date, now = new Date()) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const time = `${padTimePart(date.getHours())}:${padTimePart(date.getMinutes())}`;
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfMessageDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const daysAgo = Math.round((startOfToday.getTime() - startOfMessageDay.getTime()) / DAY_MS);

  if (daysAgo === 0) return time;
  if (daysAgo === 1) return `어제 ${time}`;
  if (daysAgo >= 2 && daysAgo < 7) return `${WEEKDAYS[date.getDay()]} ${time}`;
  if (date.getFullYear() === now.getFullYear()) return `${date.getMonth() + 1}월 ${date.getDate()}일 ${time}`;
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${time}`;
}

export function MessageTimestamp({ createdAt }: { createdAt?: string | Date }) {
  const label = formatMessageTimestamp(createdAt);
  if (!label) return null;

  const date = createdAt instanceof Date ? createdAt : new Date(createdAt!);
  const fullDateTime = new Intl.DateTimeFormat("ko-KR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);

  return (
    <time
      dateTime={date.toISOString()}
      title={fullDateTime}
      className="shrink-0 px-1.5 text-[11px] font-medium tabular-nums text-gray-400 dark:text-gray-500"
    >
      {label}
    </time>
  );
}
